var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMembership(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.274 12.2v2.303c0 .195.081.375.244.539.164.164.343.245.54.245h18.815c.195 0 .375-.082.538-.245.164-.163.246-.343.245-.54V12.2H1.274zM2.057 0h18.816c.569 0 1.054.2 1.456.601.4.401.6.887.6 1.458v12.444c0 .57-.2 1.054-.6 1.456-.401.401-.887.602-1.456.602h-5.685V22l-3.723-1.864-3.724 1.861v-5.436H2.06c-.571 0-1.057-.2-1.458-.602-.4-.4-.601-.886-.601-1.456V2.057C0 1.488.2 1.003.601.601 1.002.201 1.488 0 2.06 0m-.785 9.456h20.382V2.059c0-.197-.081-.377-.244-.54-.164-.164-.343-.246-.54-.245H2.058c-.195 0-.375.081-.539.244-.163.164-.245.343-.244.54v7.398zm0 5.047V1.273h.785c-.197 0-.377.082-.54.245-.164.164-.246.343-.245.54v12.445zm0 0c0 .195.081.375.244.539.164.164.343.245.54.245h-.784v-.784z",
    fill: "currentColor"
  })));
}

export default SvgMembership;